import { useTranslation } from 'react-i18next';
import { type PorschePaymentModuleSpecsFragment } from '../../../../../api/fragments/PorschePaymentModuleSpecs';
import {
    CreatePorschePaymentModuleDocument,
    type CreatePorschePaymentModuleMutation,
    type CreatePorschePaymentModuleMutationVariables,
} from '../../../../../api/mutations/createPorschePaymentModule';
import { type PorschePaymentModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import PorschePaymentModulePage, { type PorschePaymentModulePageProps } from '../../PorschePaymentModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<PorschePaymentModuleSpecsFragment, PorschePaymentModuleSettings> = {
    PageComponent: ({ module }: PorschePaymentModulePageProps) => <PorschePaymentModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.PorschePaymentModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreatePorschePaymentModuleMutation, CreatePorschePaymentModuleMutationVariables>({
                mutation: CreatePorschePaymentModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
